var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"etm-license-notice"},[_c('div',{staticClass:"etm-notice etm-notice-warning etm-license-notice-inner"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.licenseNoticeContent)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }